import { MouseEventHandler } from "react"
import { IconButton } from "@mui/material"
import { Refresh, Warning } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"
import { IntradayRelativeDay } from "helpers/intraday"

/**
 * Component to display intraday data information and refresh controls
 * Shows warnings, timestamps, and refresh buttons based on intraday state
 */
export default function IntradayDataInfo({
  isIntradayEnabled,
  isEndDateToday,
  currentAsOf,
  intradayRelativeDay = "today",
  showWarning,
  showRefreshButton,
  onRefresh,
  refreshButtonTooltip,
  isLoadingDates,
  useLatestDate,
}: IntradayDataInfoProps) {
  if (!isIntradayEnabled || isLoadingDates) return null

  if (showWarning) {
    return (
      <OPTooltip title={<span>
        No intraday data
        {useLatestDate && <>
          <br />
          Using end of previous day
        </>}
      </span>}
      >
        <Warning className="intraday-warning" />
      </OPTooltip>
    )
  }

  const timeStamp = isEndDateToday ? (
    <span>{intradayRelativeDay !== "today" && `${intradayRelativeDay} `}@ {currentAsOf}</span>
  ) : null

  if (showRefreshButton) {
    return (
      <span>
        {timeStamp}
        <OPTooltip title={refreshButtonTooltip}>
          <IconButton
            color="primary"
            className="intraday-reload-button"
            size="large"
            onClick={onRefresh}
          >
            <Refresh />
          </IconButton>
        </OPTooltip>
      </span>
    )
  }

  return timeStamp
}

interface IntradayDataInfoProps {
  isIntradayEnabled: boolean
  isEndDateToday: boolean
  currentAsOf: string
  intradayRelativeDay?: IntradayRelativeDay
  showWarning: boolean
  showRefreshButton: boolean
  onRefresh: MouseEventHandler<HTMLButtonElement>
  refreshButtonTooltip: string
  isLoadingDates: boolean
  useLatestDate: boolean
}
